/**
 * @generated SignedSource<<d7ff6b1cdaf7d2685914c3d0d7ecbe4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverview_widget$data = {
  readonly category: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetTodoOverview_widget";
};
export type WidgetTodoOverview_widget$key = {
  readonly " $data"?: WidgetTodoOverview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverview_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoOverview_widget",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};
})();

(node as any).hash = "18350c37ce849f1b2334097f427af640";

export default node;
